import axios from "axios";
import Api from "./../Api";

const Service = {
  async login(email, password) {
    try {
      const data = {
        "USERNAME": email,
        "PASSWORD": password
      }

      const response = await axios.post(
        `${Api}/api/LOGIN`,
        JSON.stringify(data),
        {
          headers: {
            "Content-Type": "application/json"
          },
        }
      );
      if (response.status === 200) {
        // localStorage.clear();
        localStorage.setItem("email", email);
        localStorage.setItem("password", password);


        localStorage.setItem("type", response.data.result.type);
        localStorage.setItem("PERMISSION", JSON.stringify(response.data.result.existingClient.PERMISSION));
        localStorage.setItem("UserID", response.data.result.existingClient._id);
        localStorage.setItem("MAIN_ACCOUNT_ID", response.data.result.existingClient.MAIN_ACCOUNT_ID);
        localStorage.setItem("Token", response.data.result.token);
        if (response.data.result.type === "USER") {
          localStorage.setItem("UserID", response.data.result.existingClient.SUB_ACCOUNT_ID);
          localStorage.setItem("MAIN_ACCOUNT_ID", response.data.result.existingClient.MAIN_ACCOUNT_ID);
        }

        return { success: true };
      }
    } catch (error) {
      return { success: false, error: error.response.data.message };
    }
  },
};

export default Service;
